import { render, staticRenderFns } from "./gis.vue?vue&type=template&id=0c132ad0&scoped=true"
import script from "./gis.vue?vue&type=script&lang=js"
export * from "./gis.vue?vue&type=script&lang=js"
import style0 from "./gis.vue?vue&type=style&index=0&id=0c132ad0&prod&lang=scss"
import style1 from "./gis.vue?vue&type=style&index=1&id=0c132ad0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c132ad0",
  null
  
)

export default component.exports